module.exports = __webpack_public_path__ + "img/hAS平台.f1df8e2a.svg";